import type { CityConfig } from "@/pages/city-template/types";

export const hermistonConfig: CityConfig = {
  city: "Hermiston",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "hermiston",
  route: "/cities/hermiston",
  title: "Emergency Passport Hermiston OR | Expedited Passport Umatilla County Oregon",
  metaDescription: "Emergency passport and expedited passport services in Hermiston, OR — as fast as 24 hours. Fast Passport Center serves Hermiston, Umatilla County, Pendleton, Boardman, and eastern Oregon. Registered State Dept. courier. A+ BBB rated. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Hermiston, Oregon",
  heroSubtitle: "Agricultural equipment expo in Germany next month? Family trip to BC's Okanagan Valley and passport expired? Winter produce season trip to Mexico coming up fast? Fast Passport Center helps Hermiston and Umatilla County residents get expedited passports as fast as 24 hours — entirely remotely. No drive to Seattle required from eastern Oregon.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hermiston%20Oregon%20eastern%20Oregon%20agricultural%20landscape%20with%20the%20Columbia%20River%20in%20background%20and%20vast%20irrigated%20farmland%2C%20agricultural%20processing%20facilities%20and%20watermelon%20fields%20at%20golden%20hour%2C%20dramatic%20eastern%20Oregon%20high%20desert%20sky%20with%20the%20Blue%20Mountains%20on%20horizon%2C%20classic%20Columbia%20Basin%20agricultural%20small%20town%20scenery%2C%20photorealistic%20cinematic%20quality%2C%20no%20text%20no%20people&width=1800&height=700&seq=hermiston-or-hero-01&orientation=landscape",
  heroImageAlt: "Hermiston Oregon agricultural landscape with Columbia River and Blue Mountains",
  geoPosition: "45.8404;-119.2895",
  geoPlacename: "Hermiston, Oregon",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "300 5th Ave, Suite 600, Seattle, WA 98104",
    distance: "About 290 miles northwest — approximately 5 hours by car via I-82 and I-90",
  },
  nearbyCitiesZips: [
    { name: "Hermiston", zips: "97838" },
    { name: "Pendleton", zips: "97801" },
    { name: "Boardman", zips: "97818" },
    { name: "Stanfield", zips: "97875" },
    { name: "Umatilla", zips: "97882" },
    { name: "Irrigon", zips: "97844" },
    { name: "Echo", zips: "97826" },
    { name: "Heppner", zips: "97836" },
    { name: "Milton-Freewater", zips: "97862" },
    { name: "La Grande", zips: "97850" },
    { name: "Kennewick (WA)", zips: "99336, 99337" },
    { name: "Richland (WA)", zips: "99352, 99354" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online from Hermiston", desc: "Complete your emergency or expedited passport order from anywhere in Umatilla County — no road trip to Seattle required." },
    { icon: "ri-truck-line", title: "Overnight Shipping from Hermiston or Tri-Cities", desc: "Ship your documents from FedEx Office in Kennewick WA (30 miles north) or The UPS Store in Hermiston — both support overnight delivery." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application reviewed before submission — essential for eastern Oregon residents 290 miles from the nearest regional passport agency." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Submission Access", desc: "We bypass the public appointment backlog with reserved Seattle Passport Agency slots — far faster than calling for an emergency appointment." },
  ],
  testimonials: [
    {
      name: "Rosa G.",
      location: "Hermiston, OR",
      rating: 5,
      text: "We run a large farming operation and needed passports for a European agricultural equipment expo. Fast Passport Center renewed mine in 5 business days from Hermiston. Shipped from The UPS Store in Hermiston. The Tri-Cities to Seattle I-82 drive would have been brutal — this was so much easier.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Mike J.",
      location: "Boardman, OR",
      rating: 5,
      text: "Needed an emergency passport for a family situation in Mexico. Fast Passport Center got it done in 3 days from Boardman. They guided me through the Umatilla County Clerk acceptance and expedited from there. Drove to Pasco airport and flew out. Incredible service for eastern Oregon.",
      service: "Emergency Passport Processing",
    },
    {
      name: "Sandra V.",
      location: "Umatilla, OR",
      rating: 5,
      text: "Our family farm sends people to Canada regularly for agricultural conferences. Fast Passport Center processed three renewals for us in one batch, all in 7 business days. Saved us from driving to Seattle or Portland. Eastern Oregon finally has real passport help.",
      service: "Expedited Passport Renewal (Family)",
    },
  ],
  facilities: [
    {
      id: "hermiston-post",
      name: "Hermiston Post Office",
      type: "USPS Passport Acceptance",
      address: "375 W Orchard Ave",
      city: "Hermiston",
      state: "OR",
      zip: "97838",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Downtown Hermiston — primary passport acceptance for Hermiston and west Umatilla County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance facility for Hermiston and west Umatilla County. Appointment required. Good availability compared to coastal or tourist areas.",
      icon: "ri-mail-line",
    },
    {
      id: "umatilla-county-clerk",
      name: "Umatilla County Clerk — Pendleton Office",
      type: "County Clerk Passport Acceptance",
      address: "216 SE 4th St",
      city: "Pendleton",
      state: "OR",
      zip: "97801",
      phone: "(541) 278-6236",
      hours: "Mon–Fri 8am–5pm",
      distance: "Pendleton — about 30 miles east via I-84",
      website: "https://www.umatillacounty.net/clerk",
      websiteLabel: "Umatilla County Clerk",
      notes: "Umatilla County Clerk in Pendleton accepts passport applications for all Umatilla County residents. Appointments generally available within a week.",
      icon: "ri-government-line",
    },
    {
      id: "pendleton-post",
      name: "Pendleton Post Office",
      type: "USPS Passport Acceptance",
      address: "104 SW Dorion Ave",
      city: "Pendleton",
      state: "OR",
      zip: "97801",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Pendleton — about 30 miles east via I-84",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Alternative facility in Pendleton. Works for Hermiston residents willing to drive 30 miles for better appointment options.",
      icon: "ri-mail-line",
    },
    {
      id: "kennewick-post",
      name: "Kennewick (WA) Post Office",
      type: "USPS Passport Acceptance",
      address: "525 S Auburn St",
      city: "Kennewick",
      state: "WA",
      zip: "99336",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "Kennewick WA — about 30 miles north via I-82",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Cross-state alternative for Hermiston residents. Tri-Cities (Kennewick/Pasco/Richland) offices often have significantly better appointment availability than eastern Oregon facilities.",
      icon: "ri-mail-line",
    },
    {
      id: "boardman-post",
      name: "Boardman Post Office",
      type: "USPS Passport Acceptance",
      address: "300 NW Boardman Ave",
      city: "Boardman",
      state: "OR",
      zip: "97818",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Boardman — about 25 miles west via I-84",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Small facility serving Morrow County. Limited hours. Hermiston or Pendleton offices strongly preferred.",
      icon: "ri-mail-line",
    },
    {
      id: "la-grande-post",
      name: "La Grande Post Office",
      type: "USPS Passport Acceptance",
      address: "1202 Washington Ave",
      city: "La Grande",
      state: "OR",
      zip: "97850",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–5pm",
      distance: "La Grande — about 80 miles east via I-84",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Distant option for east Umatilla County residents. Generally better for La Grande area residents than Hermiston travelers.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport from Hermiston, Oregon?",
      a: "Yes. Fast Passport Center handles emergency passport processing for Hermiston residents as fast as 24 hours. The Seattle Passport Agency is about 5 hours from Hermiston — we serve you entirely remotely via overnight shipping from FedEx Office in Kennewick WA or The UPS Store in Hermiston. Start online, we handle the rest.",
    },
    {
      q: "How fast can I get an expedited passport from Hermiston, OR?",
      a: "Expedited passport processing from Hermiston takes 2–9 business days through Fast Passport Center. Most adult renewals don't require an in-person acceptance visit — ship overnight from FedEx Office in Kennewick WA (30 miles north) or The UPS Store in Hermiston.",
    },
    {
      q: "Where is the passport acceptance office in Hermiston?",
      a: "Hermiston's primary acceptance location is the Hermiston Post Office (375 W Orchard Ave) in downtown Hermiston. Additional options include the Umatilla County Clerk in Pendleton (30 miles east) and Kennewick WA Post Office (30 miles north via I-82).",
    },
    {
      q: "Is the Tri-Cities WA area better for overnight shipping from Hermiston?",
      a: "Yes. The Tri-Cities (Kennewick, Pasco, Richland, WA) is 30 miles north via I-82 and has significantly more overnight shipping options than Hermiston — FedEx Office in Kennewick, The UPS Store in Richland, and multiple drop boxes with late cutoff times. We include Tri-Cities shipping guidance in your personalized checklist.",
    },
    {
      q: "How far is Hermiston from the Seattle Passport Agency?",
      a: "Hermiston is approximately 290 miles from the Seattle Passport Agency — about 5 hours by car via I-82 and I-90. For life-or-death emergencies requiring same-day processing, a Seattle trip may be necessary. For most urgent travel needs (2–9 business days), Fast Passport Center serves Hermiston entirely remotely.",
    },
    {
      q: "What airport do Hermiston residents use for international travel?",
      a: "Tri-Cities Airport (PSC) in Pasco WA is the primary airport for Hermiston travelers — about 35 miles north via I-82. PSC offers connections through Seattle, Portland, Denver, Salt Lake City, Minneapolis, and San Francisco to international routes worldwide. Portland International (PDX, 180 miles) and Spokane (GEG, 190 miles) are alternatives.",
    },
    {
      q: "Does Hermiston's agricultural industry generate passport needs?",
      a: "Yes — Umatilla County is one of Oregon's most productive agricultural regions (watermelons, potatoes, onions, wheat, and produce). Agricultural professionals travel internationally to equipment expos in Europe (Germany, Italy), agricultural technology conferences in Japan and the Netherlands, and Canadian agricultural industry meetings. These trips regularly require expedited passports.",
    },
    {
      q: "Can I renew my passport from Hermiston without visiting an office?",
      a: "Yes. Most adult Hermiston residents renewing their passport can do so entirely by mail — no in-person acceptance visit required for renewals. Ship overnight from FedEx Office Kennewick or The UPS Store Hermiston.",
    },
    {
      q: "Can I get a child passport from Hermiston?",
      a: "Yes. Child passports require an in-person acceptance visit at the Hermiston Post Office or Umatilla County Clerk in Pendleton — both parents must typically be present or provide notarized consent. Fast Passport Center provides the child passport checklist and expedites after the acceptance step.",
    },
    {
      q: "How much does expedited passport processing cost from Hermiston?",
      a: "Fast Passport Center pricing includes the U.S. government passport fees plus our courier service fee — typically 30–100% lower than FedEx Office or retail passport services. We provide an exact price quote at checkout before any commitment.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Hermiston", address: "1440 N 1st St, Hermiston, OR 97838", hours: "Daily 8 AM – 10 PM" },
    { name: "The UPS Store — Hermiston", address: "865 N 1st St, Hermiston, OR 97838", hours: "Mon–Fri 8:30 AM – 6 PM, Sat 10 AM – 3 PM" },
    { name: "FedEx Office — Kennewick WA", address: "731 N Columbia Center Blvd, Kennewick, WA 99336", hours: "Mon–Fri 7 AM – 10 PM, Sat 9 AM – 6 PM" },
    { name: "Walgreens — Pendleton", address: "333 S Main St, Pendleton, OR 97801", hours: "Daily 8 AM – 10 PM" },
    { name: "Costco Photo Center — Kennewick WA", address: "8502 W Gage Blvd, Kennewick, WA 99336", hours: "Mon–Fri 10 AM – 8:30 PM, Sat–Sun 9:30 AM – 6 PM" },
    { name: "Walmart — Hermiston", address: "1350 N 1st St, Hermiston, OR 97838", hours: "Daily 6 AM – 11 PM" },
    { name: "Safeway — Hermiston", address: "990 S Hwy 395, Hermiston, OR 97838", hours: "Daily 5 AM – 11 PM" },
  ],
  dmvLocations: [
    {
      name: "Hermiston Driver & Motor Vehicle Services",
      address: "950 SE Columbia Dr, Suite A, Hermiston, OR 97838",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (closed noon–1pm)",
      note: "Hermiston DMV — driver licenses, REAL ID, and state ID cards for Hermiston and west Umatilla County residents.",
      featured: true,
    },
    {
      name: "Pendleton Driver & Motor Vehicle Services",
      address: "1270 SE Byers Ave, Pendleton, OR 97801",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Pendleton DMV — larger office serving east Umatilla County and Pendleton area.",
      featured: false,
    },
    {
      name: "Kennewick WA Department of Licensing",
      address: "100 N Morain St, Suite 202, Kennewick, WA 99336",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      note: "Washington state DOL in Kennewick — alternative for WA-licensed residents in the Hermiston area.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PSC",
      name: "Tri-Cities Airport — Pasco, WA",
      distance: "Primary eastern Oregon/Washington airport — about 35 miles north via I-82 (40 minutes)",
      address: "3601 N 20th Ave, Pasco, WA 99301",
      note: "Tri-Cities Airport (PSC) is the primary airport for Hermiston and eastern Oregon travelers — a 40-minute drive north. PSC offers daily connections through Seattle, Portland, Denver, Salt Lake City, Minneapolis, and San Francisco for international routing.",
      flightUrl: "https://www.flytricities.com/",
      flightLabel: "PSC Airport Website",
      featured: true,
    },
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "About 180 miles west via I-84 (3 hours)",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "Portland International offers direct international flights but requires a 3-hour drive from Hermiston. PSC connections are the practical option for most eastern Oregon travelers.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: false,
    },
    {
      code: "GEG",
      name: "Spokane International Airport",
      distance: "About 190 miles northeast via I-90 and US-395 (3 hours)",
      address: "9000 W Airport Dr, Spokane, WA 99224",
      note: "Spokane is an alternative hub for eastern Oregon travelers — roughly equidistant to Portland from Hermiston. PSC (Tri-Cities) is the practical first choice.",
      flightUrl: "https://www.spokaneairports.net/",
      flightLabel: "GEG Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport — Hermiston & Eastern Oregon",
      description: "Agricultural equipment expo in Germany next week? Family emergency in Mexico? Canadian agricultural conference urgent? Fast Passport Center handles emergency passport processing for Hermiston and Umatilla County residents — as fast as 24 hours. Serve entirely remotely.",
      bullets: ["As fast as 24 hours processing", "Reserved Seattle agency submission", "Dedicated agent and live status tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Expedited Passport Renewal",
      description: "Passport expired during farming season and you have international travel coming up? Hermiston residents renew fast through Fast Passport Center — ship from FedEx Office Kennewick or The UPS Store Hermiston overnight, we handle the expedited submission.",
      bullets: ["Fastest renewal for eastern Oregon residents", "Ship overnight from Hermiston or Tri-Cities", "Professional document review included"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport in Hermiston or before an agricultural trade trip? We guide Umatilla County travelers through DS-64 and expedited replacement — no Seattle trip required.",
      bullets: ["DS-64 theft/loss reporting guidance", "Expedited replacement timelines available", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport — Hermiston Families",
      description: "Eastern Oregon families heading to Canada, Mexico, or international vacations need child passports. We guide you through the Hermiston Post Office or Umatilla County Clerk acceptance step.",
      bullets: ["Both parents typically required to consent", "Hermiston Post Office or Pendleton County Clerk guidance", "Expedited after in-person acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "First-Time Passport Applications",
      description: "First passport from Hermiston? In-person acceptance at the Hermiston Post Office or Umatilla County Clerk is required. We guide you through every step and expedite from there.",
      bullets: ["Step-by-step acceptance guidance for Hermiston and Pendleton facilities", "Photo location guide for Hermiston and Tri-Cities area", "Expedited processing after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Registered State Dept. Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — not a reseller. We submit through reserved agency channels at 30–100% lower prices than retail services.",
      bullets: ["State Dept. registered courier", "Best price guarantee", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Specialty Passport Services",
      description: "Name change passports, damaged passport replacement, second passports for agricultural business travelers, produce industry professionals, and frequent border-crossers in the Hermiston area.",
      bullets: ["Name change after marriage", "Damaged passport replacement", "Second passport for agricultural business travelers"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Same-day emergency passport processing for Hermiston, Oregon residents with urgent international travel needs." },
    { name: "Expedited Passport", description: "Expedited passport processing for Hermiston and Umatilla County residents in 2–9 business days." },
    { name: "Passport Renewal", description: "Fast passport renewal for Hermiston, Oregon — ship overnight from FedEx Office Kennewick WA or The UPS Store Hermiston." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement for Hermiston travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Hermiston and Umatilla County families." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier serving Hermiston, Oregon and eastern Oregon." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Booking Agricultural Trade Shows Without Checking Passport Validity", description: "Hermiston agricultural professionals attend European equipment expos (Hannover, Bologna) and Asian agricultural technology conferences regularly. Trips are often booked 3–6 months in advance, but passport issues are discovered at flight booking — 4–8 weeks before departure." },
    { icon: "ri-camera-off-line", title: "Submitting Poor-Quality Passport Photos", description: "Photos from drugstores or self-taken phone photos frequently get rejected. Use Walgreens in Hermiston or FedEx Office in Kennewick for reliable passport photo services." },
    { icon: "ri-file-damage-line", title: "Incomplete Forms or Missing Signatures", description: "One missing signature returns your application — costing weeks when you're 290 miles from Seattle. Our pre-submission review catches all errors." },
    { icon: "ri-pen-nib-line", title: "Wrong Birth Certificate Format", description: "Short-form birth certificates are rejected. We specify exactly what document format is needed based on your state of birth." },
    { icon: "ri-map-pin-time-line", title: "Ignoring Tri-Cities (WA) as a Shipping Hub from Hermiston", description: "Hermiston residents often assume they must drive to Portland or Seattle for overnight shipping. The Tri-Cities (Kennewick, Pasco, Richland WA) is 30 minutes north via I-82 with full FedEx and UPS services — faster, closer, and more reliable than Portland." },
    { icon: "ri-passport-line", title: "Not Having Passports Ready for Canadian Border Crossings", description: "Hermiston residents frequently cross into Canada for agricultural industry meetings in BC and Alberta. Canadian border crossings require a valid passport — even for business meetings. Keep your passport current if you work in the agricultural industry." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Hermiston travel date. Complete your secure order from home in minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We send a personalized document checklist — exactly what to gather, with Umatilla County and Tri-Cities acceptance location guidance." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight", description: "Drop off at FedEx Office in Kennewick WA or The UPS Store in Hermiston for overnight delivery. Both are reliable options for eastern Oregon residents." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Agency Access", description: "We submit through reserved Seattle Passport Agency slots — bypassing the public appointment backlog that stretches for weeks." },
    { number: "05", icon: "ri-passport-line", title: "Passport Shipped to Your Door", description: "Your completed passport ships directly to your Hermiston or Umatilla County address. Live status tracking included." },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Must drive to Seattle — 5 hours from Hermiston",
        "Life-or-death emergencies only",
        "Very limited appointment availability",
        "Long wait times even with appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Ship overnight from Hermiston or Tri-Cities",
        "Document review included",
        "Dedicated agent on your case",
        "Daily status updates",
        "Best price guarantee",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than USPS self-service",
        "Document review included",
        "Dedicated agent",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "Standard mail — no courier access",
        "6–13 weeks; can be longer in summer",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent",
        "Not suitable if travel is under 10 weeks away",
      ],
      highlight: false,
      muted: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — weeks-long wait, Seattle only", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Drive to Seattle — 5 hours from Hermiston", fpc: "Ship overnight from Hermiston or Tri-Cities" },
    { feature: "Processing Speed", agency: "Strict eligibility requirements", fpc: "As fast as 24 hours — multiple tiers" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Eastern Oregon Accessibility", agency: "Not designed for eastern Oregon residents", fpc: "Fully remote service via overnight shipping" },
    { feature: "Government Shutdowns", agency: "May be impacted", fpc: "Not affected" },
    { feature: "Best Price Guarantee", agency: "Govt. fees + 10-hour Seattle round trip cost", fpc: "Best price guarantee — no travel required" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Pendleton", route: "/cities/pendleton" },
    { name: "Emergency passport help in La Grande", route: "/cities/la-grande" },
    { name: "Fast passport renewal in Portland", route: "/cities/portland" },
    { name: "Rush passport services for Oregon residents", route: "/states/oregon" },
    { name: "Expedited passports statewide in Oregon", route: "/states/oregon" },
  ],
  fpcOfficeNote: "After placing your order online, we send your personalized checklist and overnight shipping instructions. Ship from FedEx Office in Kennewick WA (30 miles north via I-82) or The UPS Store in Hermiston — both available weekday evenings. No visit to our processing facility required for most services.",
  fpcOfficeDistance: "Serving Hermiston and all of eastern Oregon remotely",
  serviceAreaIntro: "Whether you are in Hermiston, Pendleton, Boardman, Stanfield, Umatilla, Irrigon, or anywhere in Umatilla County — Fast Passport Center makes emergency and expedited passport processing simple without a drive to Seattle.",
  nearbyCitiesIntro: "We serve all Umatilla County communities and surrounding areas including Hermiston, Pendleton, Boardman, Stanfield, Umatilla, Irrigon, Echo, Heppner, Milton-Freewater, and the Tri-Cities WA area.",
  howItWorksIntro: "Getting an emergency or expedited passport from Hermiston is simpler than a 5-hour drive to Seattle. Most eastern Oregon clients never visit an office.",
  mistakesIntro: "These are the most common mistakes that cause delays for Hermiston and Umatilla County passport applicants. We review your documents before submission to prevent all of them.",
  testimonialsIntro: "Real reviews from Hermiston, Boardman, and eastern Oregon travelers who needed their passports fast.",
  faqIntro: "The most common questions Hermiston and Umatilla County residents ask about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
  travelTiming: {
    title: "Travel & Passport Timing for Hermiston and Umatilla County Residents",
    intro: "Hermiston is eastern Oregon's agricultural powerhouse — the heart of Umatilla County's irrigated farmland producing world-famous watermelons, potatoes, onions, and wheat. The city's strategic location along I-82 and I-84, 30 miles south of the Tri-Cities WA metro, and its deep agricultural industry create unique international travel patterns.",
    cards: [
      {
        icon: "ri-store-2-line",
        title: "Agricultural Industry International Travel — the Hermiston Factor",
        subtitle: "Umatilla County's massive agricultural output drives global business travel",
        description: "Hermiston and Umatilla County's agricultural industry generates significant international business travel — to Germany (Hannover agricultural equipment expo, AGRITECHNICA), Italy (Bologna agricultural machinery show, EIMA), the Netherlands (agricultural technology and greenhouses), Japan (precision farming technology), and Canada (agricultural conferences in Alberta and Saskatchewan). These trips are scheduled with 6–12 weeks notice — ideal for expedited passport processing from Hermiston.",
        tip: "Agricultural professionals in Hermiston should maintain a passport with at least 12 months of validity at all times. European equipment expos have fixed dates — start the passport process 8 weeks before any international agricultural trade show.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Tri-Cities Airport (PSC) Access — Eastern Oregon's Aviation Hub",
        subtitle: "Pasco airport makes international travel accessible from Hermiston",
        description: "Tri-Cities Airport (PSC) in Pasco WA is a 40-minute drive from Hermiston — making international travel accessible from eastern Oregon. PSC connections through Seattle, Portland, Denver, and Salt Lake City open global destinations. Combined with the Tri-Cities' overnight shipping infrastructure (FedEx Office, UPS Store), Hermiston has better international travel logistics than most communities its size.",
        tip: "PSC connections make international travel feel accessible from Hermiston. Check passport expiration before booking any PSC international connection — renewals take 2–9 business days through Fast Passport Center.",
      },
      {
        icon: "ri-map-pin-2-line",
        title: "British Columbia & Alberta — Canadian Agricultural Neighbors",
        subtitle: "BC's Okanagan Valley and Alberta farming regions are frequent Hermiston travel destinations",
        description: "Hermiston's agricultural community travels frequently to Canada — British Columbia's Okanagan Valley (fruit and wine industry parallels), Alberta's agricultural heartland (cattle and grain), and Canadian agricultural conferences. These trips are often business-focused and require passport readiness with short notice — a Canadian industry meeting can come up with 2–3 weeks notice.",
        tip: "Canadian agricultural industry meetings can arise with minimal notice. Keep your passport current year-round if you work in Umatilla County agriculture — the 2–9 business day expedited window handles last-minute Canada trips perfectly.",
      },
      {
        icon: "ri-sun-line",
        title: "Mexico Winter Trips — Eastern Oregon's Annual Migration",
        subtitle: "Harsh eastern Oregon winters create strong demand for Mexican beach escapes",
        description: "Eastern Oregon winters are cold and windy — creating powerful motivation for Mexican beach escapes. Puerto Vallarta, Cabo San Lucas, and Riviera Maya are the top destinations. Hermiston families typically book in October–November for January–March travel. PSC connections through Denver or Salt Lake City make Mexican flights accessible.",
        tip: "Check passport expiration dates in September before booking that Mexico winter escape. Tri-Cities Airport connections to Mexico through Denver and SLC make the flight easy — but passport requirements don't change.",
      },
    ],
    callout: {
      icon: "ri-store-2-line",
      title: "Hermiston, Oregon — Where Agriculture Meets the World",
      description: "Hermiston sits at the intersection of world-class agriculture, strategic interstate access (I-82/I-84), and proximity to the Tri-Cities WA metro. The city's unique identity — Umatilla County's agricultural capital, home to the famous Hermiston watermelon, and gateway to both the Columbia Basin and Blue Mountains — creates a distinctive set of international travel patterns. Fast Passport Center has served Hermiston and eastern Oregon residents with expedited passports for agricultural trade shows, Canadian industry meetings, and international family vacations.",
    },
  },
  destinations: {
    title: "Where Hermiston Travelers Go — And Why Passports Get Urgent",
    intro: "These are the destinations and travel patterns we see most from Hermiston and eastern Oregon clients. Agricultural industry travel, Tri-Cities airport connections, Canadian business meetings, and winter escapes create unique passport urgency for Umatilla County residents.",
    stats: [
      { stat: "290 mi", label: "to Seattle Passport Agency — a 5-hour drive from Hermiston via I-82 and I-90" },
      { stat: "PSC", label: "Tri-Cities Airport in Pasco WA — 40 minutes north; Hermiston's primary international travel gateway" },
      { stat: "30 min", label: "to Tri-Cities WA (Kennewick/Pasco/Richland) — the overnight shipping hub for all of eastern Oregon" },
      { stat: "2–9", label: "business days for Fast Passport Center expedited processing from Hermiston" },
    ],
    destinations: [
      { name: "Germany & Italy — Agricultural Equipment Expos", context: "Hermiston farm professionals attending AGRITECHNICA (Hannover) and EIMA (Bologna) — world's largest agricultural machinery shows", urgency: "Expo dates fixed 12–18 months ahead; flight booking 8–12 weeks before departure — passport discovery at booking time", icon: "ri-store-2-line" },
      { name: "Canada — British Columbia & Alberta", context: "Agricultural industry meetings, Okanagan Valley wine/fruit industry exchanges, and Canadian cattle conferences", urgency: "Industry meetings arise with 3–6 weeks notice; Hermiston-to-BC border crossing requires valid passport", icon: "ri-map-pin-2-line" },
      { name: "Mexico — Puerto Vallarta, Cabo, Riviera Maya", context: "Winter escapes from eastern Oregon's cold — tropical beaches booked via PSC connections through Denver or SLC", urgency: "October–November booking for January–March travel; passport issues discovered 2–4 weeks before departure", icon: "ri-sun-cloudy-line" },
      { name: "Japan — Agricultural Technology Exchange", context: "Japanese precision farming technology visits — Hermiston's produce industry learns from Japanese agricultural innovation", urgency: "Technology exchange visits planned 12–16 weeks ahead; passport renewal 8 weeks before departure", icon: "ri-global-line" },
      { name: "Netherlands — Greenhouse & Agricultural Technology", context: "Dutch greenhouse and agricultural technology — Hermiston's irrigated farming parallels Dutch agricultural innovation", urgency: "Trade missions scheduled 6–12 months ahead; Schengen visa requires passport valid 3 months beyond return", icon: "ri-leaf-line" },
      { name: "Costa Rica — Eco-Adventure Winter Escape", context: "Growing destination for Hermiston families seeking tropical alternatives to Mexico — Guanacaste and Arenal regions", urgency: "November–January booking for February–April; expedition permits require passport 60 days ahead", icon: "ri-leaf-line" },
    ],
    crossLinksTitle: "Explore Nearby Oregon Service Areas",
    crossLinksDesc: "We serve travelers throughout eastern Oregon and the Columbia Basin with the same expedited passport expertise.",
    crossLinks: [
      { name: "Pendleton", route: "/cities/pendleton" },
      { name: "La Grande", route: "/cities/la-grande" },
      { name: "Portland", route: "/cities/portland" },
    ],
  },
};